import request from "../../util/request";

export function delLandingPageUrl(params) {
    return request({
        url: '/api-admin/landing_page/url/config',
        method: 'delete',
        params: params
    })
}

export function landingPageUrlList(model) {
    return request({
        url: '/api-admin/landing_page/url/config/list',
        method: 'post',
        data: model
    })
}